import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const REACTIONS = [["thumb", "👍"], ["love", "❤️"], ["masyaallah", "🌟"], ["alhamdulillah", "🤲"]];
const EMO = Object.fromEntries(REACTIONS);

export function ReactionThread({ studentId, category, itemKey, itemLabel, thread = [], onPosted, canEdit = false }) {
  const [text, setText] = useState("");
  const [editIdx, setEditIdx] = useState(-1);
  const [editText, setEditText] = useState("");
  const post = async (reaction) => {
    if (!reaction && !text.trim()) return;
    try {
      await api.post("/progress/thread", { student_id: studentId, category, item_key: itemKey, item_label: itemLabel, text: text.trim() || null, reaction: reaction || null });
      setText(""); onPosted && onPosted();
    } catch (e) { toast.error("Gagal mengirim"); }
  };
  const saveEdit = async (i) => {
    try {
      await api.post("/progress/thread/edit", { student_id: studentId, category, item_key: itemKey, index: i, text: editText });
      setEditIdx(-1); onPosted && onPosted();
    } catch (e) { toast.error("Gagal menyimpan"); }
  };
  return (
    <div className="mt-2 border-t border-stone-100 pt-2" data-testid={`thread-${category}-${itemKey}`}>
      {thread.map((c, i) => (
        <div key={i} className={`text-xs mb-1 flex items-center gap-1 ${c.by === "orangtua" ? "justify-end" : ""}`}>
          {editIdx === i ? (
            <span className="flex gap-1 w-full">
              <input value={editText} onChange={(e) => setEditText(e.target.value)} data-testid={`thread-edit-input-${category}-${itemKey}-${i}`}
                className="flex-1 min-w-0 bg-white border border-stone-200 rounded-lg py-1 px-2 text-xs outline-none focus:border-primary" />
              <button data-testid={`thread-edit-save-${category}-${itemKey}-${i}`} onClick={() => saveEdit(i)} className="text-xs font-semibold bg-primary text-white px-2 rounded-lg">OK</button>
            </span>
          ) : (
            <>
              <span className={`px-2 py-1 rounded-xl max-w-[85%] ${c.by === "orangtua" ? "bg-primary/10" : "bg-stone-100"}`}>
                <b className="text-[10px] text-stone-500">{c.by === "orangtua" ? "Orang Tua" : (c.name || (c.by === "admin" ? "Admin" : "Guru"))}:</b> {c.reaction ? EMO[c.reaction] : ""} {c.text || ""}
                {(c.edited || c.edited_by) && <i className="text-[9px] text-stone-400 not-italic ml-1">(Diedit)</i>}
              </span>
              {canEdit && c.by !== "orangtua" && (c.text || "") && (
                <button data-testid={`thread-edit-${category}-${itemKey}-${i}`} onClick={() => { setEditIdx(i); setEditText(c.text || ""); }}
                  className="text-[10px] text-blue-600 font-semibold shrink-0">Edit</button>
              )}
            </>
          )}
        </div>
      ))}
      <div className="flex gap-1 mt-1">
        {REACTIONS.map(([k, e]) => (
          <button key={k} data-testid={`react-${category}-${itemKey}-${k}`} onClick={() => post(k)}
            className="w-7 h-7 rounded-full bg-stone-100 text-sm flex items-center justify-center active:scale-90 transition-transform">{e}</button>
        ))}
      </div>
      <div className="flex gap-1.5 mt-1.5">
        <input data-testid={`thread-input-${category}-${itemKey}`} value={text} onChange={(e) => setText(e.target.value)}
          placeholder="Tulis komentar..." className="flex-1 min-w-0 bg-white border border-stone-200 rounded-lg py-1.5 px-2 text-xs outline-none focus:border-primary" />
        <button data-testid={`thread-send-${category}-${itemKey}`} onClick={() => post(null)}
          className="text-xs font-semibold bg-primary text-white px-3 rounded-lg active:scale-95 transition-transform">Kirim</button>
      </div>
    </div>
  );
}
